import SuperFetch from "../../utils/superFetch"
import moment from "moment"

export const getDeliveryAnalyticsData = async (startTime, endTime) => {
    
    let response = await SuperFetch(`/api/send/analytics/getDeliveries?endTime=${endTime}&startTime=${startTime}`, "get" )
    
    return response.data
}

export const getOrderBreakdown = async (startTime, endTime) => {
    let response = await SuperFetch(`/api/send/analytics/orderBreakdown?endTime=${endTime}&startTime=${startTime}`, "get" )
    
    return response.data
}

export const getPaymentBreakdownAnalytics = async (startTime, endTime) => {
    let response = await SuperFetch(`/api/send/analytics/paymentBreakdown?endTime=${endTime}&startTime=${startTime}`, "get" )
    
    return response.data
}